import { Atom } from 'AppReact';
import styled from 'styled-components';
import device from 'utils/device'

const template = styled.div`
  margin-left: 12px;
  cursor: pointer;

  @media ${device.tablet} {
    margin-left: 4px;
  }
`;

export default Atom({ type: 'button', dataType: 'object', template })